import styles from "./AppRadioGroup.module.scss";

type AppRadioGroupProps = {
  options: { id: string; label: string; value: string }[];
  selectedValue: string;
  onChange: (value: string) => void;
  name?: string;
};

export const AppRadioGroup = ({
  options = [],
  selectedValue,
  onChange,
  name,
}: AppRadioGroupProps) => (
  <form data-testid="app-radio-group">
    {options.map((option) => (
      <div key={option.id} className={styles.optionContainer}>
        <input
          id={option.id}
          type="radio"
          name={name}
          value={option.value}
          checked={selectedValue === option.value}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            onChange(event.target.value);
          }}
        />
        <label htmlFor={option.id} key={option.value}>
          {option.label}
        </label>
      </div>
    ))}
  </form>
);
